module.exports = __webpack_public_path__ + "1ef7c8f15994c2e9058542c14506a1f5.svg";